// @flow

import React from "react";

const Upcoming = ({ broadcast }): React$Element<div> => {
  return (
    <div className="l-row margin-top-2 flex-lg justify-between">
      <div className="l-col-12-l">
        <div className="flex flex-wrap justify-between items-center">
          <a className="flex items-center" href={`/kinderfilms/${broadcast.slug}`}>
            <img src={broadcast.thumbnail} alt={broadcast.title} className="flex-0 h-12 h-24-md" />
            <div className="flex-1 flex-md margin-right-2">
              <div className="underline margin-left-1">
                {broadcast.title}
              </div>
              <div className="margin-left-1">
                {broadcast.dateFromNow} op tv.
              </div>
            </div>
          </a>
          <div className="margin-top-2 margin-top-2-md flex-grow">
            <a href="/tv-kijken" className="row__more margin-right-0">Bekijk de gids</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Upcoming;
